/**
 * Tour Steps Configuration for Dashboard TourGuide
 * This file defines all the tour steps for the application
 * Static values are used here - can be replaced with API calls later
 */
import { markTourAsCompleted } from './helpers/tourGuideHelper';

const steps = [
	{
		selector: '[data-tour="dashboard-welcome"]',
		content: ({ setIsOpen, currentStep, stepsLength, setCurrentStep }) => {
			const isDarkTheme = document.documentElement.getAttribute('theme') === 'dark';
			return (
				<div style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}>
					<div style={{ marginBottom: '20px' }}>
						<h2 style={{
							margin: '0 0 10px 0',
							fontSize: '26px',
							fontWeight: '700',
							color: '#1a1a1a',
							background: 'linear-gradient(135deg, #3aba6f 0%, #2d8f52 100%)',
							WebkitBackgroundClip: 'text',
							WebkitTextFillColor: 'transparent',
							backgroundClip: 'text',
						}}>
							👋 Welcome!
						</h2>
						<p style={{
							margin: '0',
							fontSize: '13px',
							color: '#999999',
							fontWeight: '500',
							textTransform: 'uppercase',
							letterSpacing: '0.5px',
						}}>
							Step {currentStep + 1} of {stepsLength}
						</p>
					</div>
					<p style={{
						margin: '0 0 24px 0',
						fontSize: '15px',
						lineHeight: '1.8',
						color: '#4b5563',
						fontWeight: '500',
					}}>
						I'm your personal assistant. Let me give you a quick tour of all the features available on your dashboard.
					</p>
					<div style={{ 
						marginTop: '24px', 
						display: 'flex', 
						gap: '12px',
						justifyContent: 'space-between',
					}}>
						<button
							onClick={() => setIsOpen(false)}
							style={{
								padding: '10px 20px',
								backgroundColor: '#f0f0f0',
								color: '#1a1a1a',
								border: 'none',
								borderRadius: '8px',
								cursor: 'pointer',
								fontSize: '14px',
								fontWeight: '600',
								transition: 'all 0.3s ease',
								flex: 1,
								textAlign: 'center',
							}}
							onMouseEnter={(e) => {
								e.target.style.backgroundColor = '#e0e0e0';
								e.target.style.transform = 'translateY(-1px)';
							}}
							onMouseLeave={(e) => {
								e.target.style.backgroundColor = '#f0f0f0';
								e.target.style.transform = 'translateY(0)';
							}}
						>
							Skip Tour
						</button>
						<button
							onClick={() => setCurrentStep(currentStep + 1)}
							style={{
								padding: '10px 20px',
								backgroundColor: '#3aba6f',
								color: 'white',
								border: 'none',
								borderRadius: '8px',
								cursor: 'pointer',
								fontSize: '14px',
								fontWeight: '600',
								transition: 'all 0.3s ease',
								flex: 1,
								textAlign: 'center',
								boxShadow: '0 4px 12px rgba(58, 186, 111, 0.3)',
							}}
							onMouseEnter={(e) => {
								e.target.style.transform = 'translateY(-2px)';
								e.target.style.boxShadow = '0 6px 16px rgba(58, 186, 111, 0.4)';
							}}
							onMouseLeave={(e) => {
								e.target.style.transform = 'translateY(0)';
								e.target.style.boxShadow = '0 4px 12px rgba(58, 186, 111, 0.3)';
							}}
						>
							Next →
						</button>
					</div>
				</div>
			);
		},
	},
	{
		selector: '[data-tour="pending-appointments"]',
		content: ({ setCurrentStep, currentStep, stepsLength }) => (
			<div style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}>
				<div style={{ marginBottom: '16px' }}>
					<h3 style={{
						margin: '0 0 8px 0',
						fontSize: '20px',
						fontWeight: '700',
						color: '#1a1a1a',
					}}>📋 Pending Appointments</h3>
					<p style={{
						margin: '0',
						fontSize: '13px',
						color: '#999999',
						fontWeight: '500',
						textTransform: 'uppercase',
						letterSpacing: '0.5px',
					}}>Step {currentStep + 1} of {stepsLength}</p>
				</div>
				<p style={{
					margin: '0 0 24px 0',
					fontSize: '15px',
					lineHeight: '1.8',
					color: '#4b5563',
					fontWeight: '500',
				}}>
					This card shows all your upcoming appointments that are pending. Click on it to view the full list and manage your schedule.
				</p>
				<div style={{ marginTop: '24px', display: 'flex', gap: '12px' }}>
					<button
						onClick={() => setCurrentStep(currentStep - 1)}
						style={{
							padding: '10px 18px',
							backgroundColor: '#f0f0f0',
							color: '#1a1a1a',
							border: 'none',
							borderRadius: '8px',
							cursor: 'pointer',
							fontSize: '14px',
							fontWeight: '600',
							transition: 'all 0.3s ease',
							flex: 1,
							textAlign: 'center',
						}}
						onMouseEnter={(e) => {
							e.target.style.backgroundColor = '#e0e0e0';
							e.target.style.transform = 'translateY(-1px)';
						}}
						onMouseLeave={(e) => {
							e.target.style.backgroundColor = '#f0f0f0';
							e.target.style.transform = 'translateY(0)';
						}}>
						← Back
					</button>
					<button
						onClick={() => setCurrentStep(currentStep + 1)}
						style={{
							padding: '10px 18px',
							backgroundColor: '#3aba6f',
							color: 'white',
							border: 'none',
							borderRadius: '8px',
							cursor: 'pointer',
							fontSize: '14px',
							fontWeight: '600',
							transition: 'all 0.3s ease',
							flex: 1,
							textAlign: 'center',
							boxShadow: '0 4px 12px rgba(58, 186, 111, 0.3)',
						}}
						onMouseEnter={(e) => {
							e.target.style.transform = 'translateY(-2px)';
							e.target.style.boxShadow = '0 6px 16px rgba(58, 186, 111, 0.4)';
						}}
						onMouseLeave={(e) => {
							e.target.style.transform = 'translateY(0)';
							e.target.style.boxShadow = '0 4px 12px rgba(58, 186, 111, 0.3)';
						}}>
						Next →
					</button>
				</div>
			</div>
		),
	},
	{
		selector: '[data-tour="completed-appointments"]',
		content: ({ setCurrentStep, currentStep, stepsLength }) => (
			<div style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}>
				<div style={{ marginBottom: '16px' }}>
					<h3 style={{
						margin: '0 0 8px 0',
						fontSize: '20px',
						fontWeight: '700',
						color: '#1a1a1a',
					}}>✅ Completed Appointments</h3>
					<p style={{
						margin: '0',
						fontSize: '13px',
						color: '#999999',
						fontWeight: '500',
						textTransform: 'uppercase',
						letterSpacing: '0.5px',
					}}>Step {currentStep + 1} of {stepsLength}</p>
				</div>
				<p style={{
					margin: '0 0 24px 0',
					fontSize: '15px',
					lineHeight: '1.8',
					color: '#4b5563',
					fontWeight: '500',
				}}>
					View your completed appointments here. This helps you track your business performance and customer satisfaction.
				</p>
				<div style={{ marginTop: '24px', display: 'flex', gap: '12px' }}>
					<button
						onClick={() => setCurrentStep(currentStep - 1)}
						style={{
							padding: '10px 18px',
							backgroundColor: '#f0f0f0',
							color: '#1a1a1a',
							border: 'none',
							borderRadius: '8px',
							cursor: 'pointer',
							fontSize: '14px',
							fontWeight: '600',
							transition: 'all 0.3s ease',
							flex: 1,
							textAlign: 'center',
						}}
						onMouseEnter={(e) => {
							e.target.style.backgroundColor = '#e0e0e0';
							e.target.style.transform = 'translateY(-1px)';
						}}
						onMouseLeave={(e) => {
							e.target.style.backgroundColor = '#f0f0f0';
							e.target.style.transform = 'translateY(0)';
						}}>
						← Back
					</button>
					<button
						onClick={() => setCurrentStep(currentStep + 1)}
						style={{
							padding: '10px 18px',
							backgroundColor: '#3aba6f',
							color: 'white',
							border: 'none',
							borderRadius: '8px',
							cursor: 'pointer',
							fontSize: '14px',
							fontWeight: '600',
							transition: 'all 0.3s ease',
							flex: 1,
							textAlign: 'center',
							boxShadow: '0 4px 12px rgba(58, 186, 111, 0.3)',
						}}
						onMouseEnter={(e) => {
							e.target.style.transform = 'translateY(-2px)';
							e.target.style.boxShadow = '0 6px 16px rgba(58, 186, 111, 0.4)';
						}}
						onMouseLeave={(e) => {
							e.target.style.transform = 'translateY(0)';
							e.target.style.boxShadow = '0 4px 12px rgba(58, 186, 111, 0.3)';
						}}>
						Next →
					</button>
				</div>
			</div>
		),
	},
	{
		selector: '[data-tour="cancelled-appointments"]',
		content: ({ setCurrentStep, currentStep, stepsLength }) => (
			<div style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}>
				<div style={{ marginBottom: '16px' }}>
					<h3 style={{
						margin: '0 0 8px 0',
						fontSize: '20px',
						fontWeight: '700',
						color: '#1a1a1a',
					}}>❌ Cancelled Appointments</h3>
					<p style={{
						margin: '0',
						fontSize: '13px',
						color: '#999999',
						fontWeight: '500',
						textTransform: 'uppercase',
						letterSpacing: '0.5px',
					}}>Step {currentStep + 1} of {stepsLength}</p>
				</div>
				<p style={{
					margin: '0 0 24px 0',
					fontSize: '15px',
					lineHeight: '1.8',
					color: '#4b5563',
					fontWeight: '500',
				}}>
					This section shows all your cancelled appointments. You can review and analyze cancellation patterns to improve your business.
				</p>
				<div style={{ marginTop: '24px', display: 'flex', gap: '12px' }}>
					<button
						onClick={() => setCurrentStep(currentStep - 1)}
						style={{
							padding: '10px 18px',
							backgroundColor: '#f0f0f0',
							color: '#1a1a1a',
							border: 'none',
							borderRadius: '8px',
							cursor: 'pointer',
							fontSize: '14px',
							fontWeight: '600',
							transition: 'all 0.3s ease',
							flex: 1,
							textAlign: 'center',
						}}
						onMouseEnter={(e) => {
							e.target.style.backgroundColor = '#e0e0e0';
							e.target.style.transform = 'translateY(-1px)';
						}}
						onMouseLeave={(e) => {
							e.target.style.backgroundColor = '#f0f0f0';
							e.target.style.transform = 'translateY(0)';
						}}>
						← Back
					</button>
					<button
						onClick={() => setCurrentStep(currentStep + 1)}
						style={{
							padding: '10px 18px',
							backgroundColor: '#3aba6f',
							color: 'white',
							border: 'none',
							borderRadius: '8px',
							cursor: 'pointer',
							fontSize: '14px',
							fontWeight: '600',
							transition: 'all 0.3s ease',
							flex: 1,
							textAlign: 'center',
							boxShadow: '0 4px 12px rgba(58, 186, 111, 0.3)',
						}}
						onMouseEnter={(e) => {
							e.target.style.transform = 'translateY(-2px)';
							e.target.style.boxShadow = '0 6px 16px rgba(58, 186, 111, 0.4)';
						}}
						onMouseLeave={(e) => {
							e.target.style.transform = 'translateY(0)';
							e.target.style.boxShadow = '0 4px 12px rgba(58, 186, 111, 0.3)';
						}}>
						Next →
					</button>
				</div>
			</div>
		),
	},
	{
		selector: '[data-tour="expired-appointments"]',
		content: ({ setCurrentStep, currentStep, stepsLength }) => (
			<div style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}>
				<div style={{ marginBottom: '16px' }}>
					<h3 style={{
						margin: '0 0 8px 0',
						fontSize: '20px',
						fontWeight: '700',
						color: '#1a1a1a',
					}}>⏰ Expired Appointments</h3>
					<p style={{
						margin: '0',
						fontSize: '13px',
						color: '#999999',
						fontWeight: '500',
						textTransform: 'uppercase',
						letterSpacing: '0.5px',
					}}>Step {currentStep + 1} of {stepsLength}</p>
				</div>
				<p style={{
					margin: '0 0 24px 0',
					fontSize: '15px',
					lineHeight: '1.8',
					color: '#4b5563',
					fontWeight: '500',
				}}>
					View appointments that have expired. This helps you understand appointment fulfillment and identify patterns.
				</p>
				<div style={{ marginTop: '24px', display: 'flex', gap: '12px' }}>
					<button
						onClick={() => setCurrentStep(currentStep - 1)}
						style={{
							padding: '10px 18px',
							backgroundColor: '#f0f0f0',
							color: '#1a1a1a',
							border: 'none',
							borderRadius: '8px',
							cursor: 'pointer',
							fontSize: '14px',
							fontWeight: '600',
							transition: 'all 0.3s ease',
							flex: 1,
							textAlign: 'center',
						}}
						onMouseEnter={(e) => {
							e.target.style.backgroundColor = '#e0e0e0';
							e.target.style.transform = 'translateY(-1px)';
						}}
						onMouseLeave={(e) => {
							e.target.style.backgroundColor = '#f0f0f0';
							e.target.style.transform = 'translateY(0)';
						}}>
						← Back
					</button>
					<button
						onClick={() => setCurrentStep(currentStep + 1)}
						style={{
							padding: '10px 18px',
							backgroundColor: '#3aba6f',
							color: 'white',
							border: 'none',
							borderRadius: '8px',
							cursor: 'pointer',
							fontSize: '14px',
							fontWeight: '600',
							transition: 'all 0.3s ease',
							flex: 1,
							textAlign: 'center',
							boxShadow: '0 4px 12px rgba(58, 186, 111, 0.3)',
						}}
						onMouseEnter={(e) => {
							e.target.style.transform = 'translateY(-2px)';
							e.target.style.boxShadow = '0 6px 16px rgba(58, 186, 111, 0.4)';
						}}
						onMouseLeave={(e) => {
							e.target.style.transform = 'translateY(0)';
							e.target.style.boxShadow = '0 4px 12px rgba(58, 186, 111, 0.3)';
						}}>
						Next →
					</button>
				</div>
			</div>
		),
	},
	{
		selector: '[data-tour="add-order-button"]',
		content: ({ setCurrentStep, currentStep, setIsOpen, stepsLength }) => (
			<div style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}>
				<div style={{ marginBottom: '16px' }}>
					<h3 style={{
						margin: '0 0 8px 0',
						fontSize: '20px',
						fontWeight: '700',
						color: '#1a1a1a',
					}}>➕ Add Order</h3>
					<p style={{
						margin: '0',
						fontSize: '13px',
						color: '#999999',
						fontWeight: '500',
						textTransform: 'uppercase',
						letterSpacing: '0.5px',
					}}>Step {currentStep + 1} of {stepsLength} - Final</p>
				</div>
				<p style={{
					margin: '0 0 24px 0',
					fontSize: '15px',
					lineHeight: '1.8',
					color: '#4b5563',
					fontWeight: '500',
				}}>
					Use this button to quickly add new orders to your system. You can create new appointments or products from here.
				</p>
				<div style={{ marginTop: '24px', display: 'flex', gap: '12px' }}>
					<button
						onClick={() => setCurrentStep(currentStep - 1)}
						style={{
							padding: '10px 18px',
							backgroundColor: '#f0f0f0',
							color: '#1a1a1a',
							border: 'none',
							borderRadius: '8px',
							cursor: 'pointer',
							fontSize: '14px',
							fontWeight: '600',
							transition: 'all 0.3s ease',
							flex: 1,
							textAlign: 'center',
						}}
						onMouseEnter={(e) => {
							e.target.style.backgroundColor = '#e0e0e0';
							e.target.style.transform = 'translateY(-1px)';
						}}
						onMouseLeave={(e) => {
							e.target.style.backgroundColor = '#f0f0f0';
							e.target.style.transform = 'translateY(0)';
						}}>
						← Back
					</button>
					<button
						onClick={() => { markTourAsCompleted(); setIsOpen(false); }}
						style={{
							padding: '10px 18px',
							backgroundColor: '#3aba6f',
							color: 'white',
							border: 'none',
							borderRadius: '8px',
							cursor: 'pointer',
							fontSize: '14px',
							fontWeight: '600',
							transition: 'all 0.3s ease',
							flex: 1,
							textAlign: 'center',
							boxShadow: '0 4px 12px rgba(58, 186, 111, 0.3)',
						}}
						onMouseEnter={(e) => {
							e.target.style.transform = 'translateY(-2px)';
							e.target.style.boxShadow = '0 6px 16px rgba(58, 186, 111, 0.4)';
						}}
						onMouseLeave={(e) => {
							e.target.style.transform = 'translateY(0)';
							e.target.style.boxShadow = '0 4px 12px rgba(58, 186, 111, 0.3)';
						}}>
						✓ Finish Tour
					</button>
				</div>
			</div>
		),
	},
];

export const styles = {
	popover: (base) => ({
		...base,
		backgroundColor: '#ffffff',
		color: '#1a1a1a',
		borderRadius: '12px',
		padding: '24px',
		boxShadow: '0 8px 30px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.05)',
		maxWidth: '420px',
		fontFamily: 'system-ui, -apple-system, sans-serif',
		transform: 'translateY(0)',
		transition: 'all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)',
	}),
	badge: (base) => ({
		...base,
		backgroundColor: '#3aba6f',
		color: '#ffffff',
		fontSize: '12px',
		borderRadius: '6px',
		padding: '6px 10px',
		fontWeight: '600',
	}),
	maskArea: (base) => ({
		...base,
		rx: 12,
		fill: 'rgba(0, 0, 0, 0.15)',
	}),
	maskRect: (base) => ({
		...base,
		fill: 'rgba(0, 0, 0, 0.15)',
	}),
	highlightedArea: (base) => ({
		...base,
		boxShadow: '0 0 0 4px rgba(58, 186, 111, 0.2)',
		borderRadius: '12px',
		transition: 'all 0.3s ease',
	}),
};

export default steps;
